import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from '.';
import { getTenantFromUrl, getThemeConfig } from '../utils/tenant';
import themes from '../config/themes';

export default function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    // Detect tenant from URL on mount
    const tenant = getTenantFromUrl();
    const themeConfig = getThemeConfig(tenant);
    setTheme(themeConfig);

    // Set CSS custom properties for future color customization
    if (themeConfig.colors && Object.keys(themeConfig.colors).length > 0) {
      const root = document.documentElement;
      Object.entries(themeConfig.colors).forEach(([key, value]) => {
        root.style.setProperty(`--theme-${key}`, value);
      });
    }
  }, []);

  const themeValue = useMemo(() => theme, [theme]);

  // Return children with fallback theme while loading
  if (!theme) {
    return <ThemeContext.Provider value={themes.initio}>{children}</ThemeContext.Provider>;
  }

  return <ThemeContext.Provider value={themeValue}>{children}</ThemeContext.Provider>;
}

ThemeProvider.propTypes = { children: PropTypes.element.isRequired };

